import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lock, ArrowRight, BookOpen } from 'lucide-react';

interface SubscriptionLockedStateProps {
  titleKey?: string;
  descriptionKey?: string;
}

export const SubscriptionLockedState: React.FC<SubscriptionLockedStateProps> = ({
  titleKey = 'subscriptionLock.title',
  descriptionKey = 'subscriptionLock.description',
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
      <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
        <Lock className="w-7 h-7 text-primary" />
      </div>
      <h2 className="text-xl font-bold text-gray-900 mb-2">{t(titleKey)}</h2>
      <p className="text-gray-600 max-w-xl mx-auto mb-6">{t(descriptionKey)}</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/pricing"
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-primary px-6 py-3 font-semibold text-white transition-all hover:-translate-y-0.5 hover:brightness-110"
        >
          {t('subscriptionLock.viewPlans')}
          <ArrowRight className="w-4 h-4" />
        </Link>
        <Link
          to="/try-free"
          className="inline-flex items-center justify-center gap-2 rounded-2xl border border-primary/20 bg-white px-6 py-3 font-semibold text-primary transition-all hover:border-primary/50"
        >
          <BookOpen className="w-4 h-4" />
          {t('subscriptionLock.startFreeExam')}
        </Link>
      </div>
    </div>
  );
};

export default SubscriptionLockedState;
